// First Letter Caps
import dayjs from "dayjs";
export const capitalizeFirstLetter = (str) => {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
  };

  // Format Date
export const formatDate = (date) => (date ? dayjs(date).format("YYYY-MM-DD") : null);
// Format Time
export const formatTime = (time) => (time ? dayjs(time).format("HH:mm:ss") : null);

export const formatDateGmt = (date) => {
  return new Date(date).toLocaleDateString("en-CA").replace(/-/g, "-"); 
};
export const formatDateGn = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-GB'); // 'en-GB' gives dd-mm-yyyy format
};

export const normalizeSpaces = (str) => {
  return str.replace(/\s+/g, ' ');
}

export const extractPhoneNumber = (countryCode, fullNumber) => {
  let countryCodeStr = countryCode?.toString(); // Convert country code to string

  // Scenario 1: If fullNumber already contains "+<countryCode>", return as is
  if (fullNumber?.startsWith(`+${countryCodeStr}`)) {
      return fullNumber;
  }

  // Scenario 2: If fullNumber starts with countryCode but without "+", add "+"
  if (fullNumber?.startsWith(countryCodeStr)) {
      return `+${countryCodeStr} ${fullNumber.substring(countryCodeStr.length)}`;
  }

  return fullNumber; // If neither case matches, return the number as is
};

